import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { getDefaultMetricDisplay } from "helpers/metrics"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "asset-view-content-set"
const PREFERENCE_FIELDS = [
  "selectedCategory",
  "selectedMetricDisplay",
]

const DEFAULT_STATE = {
  selectedCategory: "overall",
  selectedMetricDisplay: getDefaultMetricDisplay("contentSet"),
}

export const CONTENT_SET_CONTEXT = createContext()

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedCategory":
        draft.selectedCategory = action.selectedCategory
        break
      case "setSelectedMetricDisplay":
        draft.selectedMetricDisplay = action.selectedMetricDisplay
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export default function ContentSetContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)
  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedCategory: (selectedCategory) => dispatch({ type: "setSelectedCategory", selectedCategory }),
    setSelectedMetricDisplay: (selectedMetricDisplay) => dispatch({ type: "setSelectedMetricDisplay", selectedMetricDisplay }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <CONTENT_SET_CONTEXT.Provider value={contextValue}>
    {children}
  </CONTENT_SET_CONTEXT.Provider>
}
